import { Component, Input, OnInit } from '@angular/core';
import { TransportDetail } from '../../gantt-chart.model';

@Component({
  selector: 'app-transport-item',
  templateUrl: './transport-item.component.html',
  styleUrls: ['./transport-item.component.scss']
})
export class TransportItemComponent implements OnInit {

  transport: TransportDetail;

  @Input() scale : number;

  @Input() selected: boolean;

  @Input() offsetBefore: number;

  @Input('transport') set setTransport(value: TransportDetail) {
    this.transport = value;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
